import { render, staticRenderFns } from "./searchInput.vue?vue&type=template&id=8964c31a&scoped=true"
import script from "./searchInput.vue?vue&type=script&lang=js"
export * from "./searchInput.vue?vue&type=script&lang=js"
import style0 from "./searchInput.vue?vue&type=style&index=0&id=8964c31a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8964c31a",
  null
  
)

export default component.exports